import { defineMessages } from 'react-intl'

export default defineMessages({
  placeholder: {
    id: 'search.location-placeholder',
    defaultMessage: 'Location',
  },
})
